// IMPORTANT: This must be the first import to initialize window.BIOS before other modules load
import "./init-bios";

import React from "react";
import {createRoot} from "react-dom/client"
import {configureDayJs} from "./common/utils/times";
import {LoadingPage} from "./components/pages/LoadingPage";
import {NeurotuneProvider} from "./components/NeurotuneProvider";
import {ErrorBoundary} from "./components/ErrorBoundary";

configureDayJs()

const initApp = () => {
    const root = document.getElementById("root")

    if (!root)
        throw new DOMException("Can't find element with root id")

    createRoot(root).render(
        React.createElement(ErrorBoundary, {
            children: React.createElement(NeurotuneProvider, {
                children: React.createElement(LoadingPage, {})
            })
        })
    )
}

// Load the App into the root DOM
// Handle both cases: DOM already loaded (in Vite dev) and DOM still loading
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initApp();
    });
} else {
    // DOM already loaded
    initApp();
}
